import { render, staticRenderFns } from "./VirtualServiceAccounts.vue?vue&type=template&id=b258920c&"
import script from "./VirtualServiceAccounts.vue?vue&type=script&lang=js&"
export * from "./VirtualServiceAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports